import { base } from './base.js';

export function deviceID({ deviceId = '', button = null }) {
  const id = deviceId ? (deviceId.length > 9 ? deviceId.substring(deviceId.length - 9) : deviceId) : '';
  return base({
    icon: 'phone',
    title: window.strings.device,
    content: id,
    button: button ?? { title: window.strings.manage },
  });
}
